import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import ConfirmAction from 'helpers/ConfirmationModal.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import CitiesTable from './_CitiesTable.js';
import EditCity from './_EditCity.js';
const URI = ApiEndpoint + 'configuration/';

const Cities = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [states, setStates] = useState(null);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [idMunicipioToDelete, setIdMunicipioToDelete] = useState(false);
  const [idMunicipioToEdit, setIdMunicipioToEdit] = useState(0);

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    getCitiesList(selectedState);
  };
  const handleClose = () => {
    setOpenModal(false);
    getCitiesList(selectedState);
  };

  const DeleteConfirmed = isConfirmed => {
    if (!isConfirmed) {
      return;
    }
    httpClient(
      'DELETE',
      URI + 'cities/' + idMunicipioToDelete,
      {},
      userData.token
    )
      .then(function (response) {
        if (response.data.error) {
          return;
        }
        getCitiesList();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getStatesList = async () => {
    setStates(null);

    httpClient('GET', URI + 'states', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStates(response.data);
          setSelectedState(1);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCitiesList = async () => {
    console.log('entre a getCitiesList');
    setCities(null);

    httpClient('GET', URI + 'cities/' + selectedState, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setCities(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getStatesList();
    getCitiesList(1);
  }, []);

  useEffect(() => {
    if (selectedState != null && selectedState != 0)
      getCitiesList(selectedState);
  }, [selectedState]);

  return (
    <>
      {cities && (
        <CitiesTable
          cities={cities}
          states={states}
          setIdMunicipio={setIdMunicipioToEdit}
          setOpenModa={setOpenModal}
          setIdMunicipioToDelete={setIdMunicipioToDelete}
          setOpenModal={setOpenModal}
          setOpenConfirm={setOpenConfirm}
          setFilter={setSelectedState}
          filterState={selectedState}
        ></CitiesTable>
      )}
      {openConfirm && (
        <ConfirmAction
          message={'Desea eliminar el registro?'}
          title={'Confirmacion'}
          handleClose={handleCloseConfirm}
          open={openConfirm}
          ConfirmAction={DeleteConfirmed}
        ></ConfirmAction>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={(idMunicipioToEdit > 0 ? 'Editar' : 'Agregar') + ' Municipio'}
          openModal={openModal}
          closeModal={handleClose}
        >
          <></>
          {/* <EditInstitucion
            idInstitucion={idInstitucion}
            closeModal={handleClose}
          /> */}
          <EditCity
            closeModal={handleClose}
            idCity={idMunicipioToEdit}
          ></EditCity>
        </MyModal>
      )}
    </>
  );
};

export default Cities;
